/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Account_Signincta2Inputs */

const he_extension_popup_account_signincta2 = /** @type {(inputs: Extension_Popup_Account_Signincta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחברות ל-pricedrop.co.il`)
};

const en_extension_popup_account_signincta2 = /** @type {(inputs: Extension_Popup_Account_Signincta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in on pricedrop.co.il`)
};

/**
* | output |
* | --- |
* | "Sign in on pricedrop.co.il" |
*
* @param {Extension_Popup_Account_Signincta2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_account_signincta2 = /** @type {((inputs?: Extension_Popup_Account_Signincta2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Account_Signincta2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_account_signincta2(inputs)
	return en_extension_popup_account_signincta2(inputs)
});
export { extension_popup_account_signincta2 as "extension_popup_account_signInCta" }